module.exports = __webpack_public_path__ + "static/media/t11.3b71edbb.jpg";